export default __webpack_public_path__ + "static/media/package.0060dc89.png";